module.exports = __webpack_public_path__ + "img/instagram.f4a5e8f6.svg";